/**
 * @generated SignedSource<<b951074a0ca2646f1f56ac16a6c6fcb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateVideoElementButton_VimeoSourceQuery$variables = Record<PropertyKey, never>;
export type CreateVideoElementButton_VimeoSourceQuery$data = {
  readonly Admin: {
    readonly VimeoVideoSource: {
      readonly GetDefaultVimeoVideoSource: {
        readonly id: string;
      } | null | undefined;
    };
  };
};
export type CreateVideoElementButton_VimeoSourceQuery = {
  response: CreateVideoElementButton_VimeoSourceQuery$data;
  variables: CreateVideoElementButton_VimeoSourceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminQueryType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VimeoVideoSourceAdminSchema",
        "kind": "LinkedField",
        "name": "VimeoVideoSource",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vimeo_VimeoVideoSource",
            "kind": "LinkedField",
            "name": "GetDefaultVimeoVideoSource",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateVideoElementButton_VimeoSourceQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CreateVideoElementButton_VimeoSourceQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a6f66f15337b23b0fcb28a285fea8ef8",
    "id": null,
    "metadata": {},
    "name": "CreateVideoElementButton_VimeoSourceQuery",
    "operationKind": "query",
    "text": "query CreateVideoElementButton_VimeoSourceQuery {\n  Admin {\n    VimeoVideoSource {\n      GetDefaultVimeoVideoSource {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "32e42fa7f8beb29d911e8a84cbe49b64";

export default node;
